import React from "react";
import "./CoverageResultsStyle/CoverageResultsStyle.scss";

export const OutOfPocket = props => {
    function setTwoDecimalNumber(event) {
        event.value = parseInt(event.target.value).toFixed(2);
    }
    return (
        <div className="margin_plan_details_card">
            <div className="in_network_label">{props.title}</div>
            <div className="individual_label">{props.detailsObj?.level}</div>
            <div className="calender_amount_inside_deductible_box" min="0" onChange={setTwoDecimalNumber} value="0.00">
                ${props.detailsObj?.amount ?? 0}
            </div>
            <hr className="separator_line_deductible" />
            <div className="remaining_total_amount_name">
                {props.detailsObj?.payerNotes?.map(y => {
                    // eslint-disable-next-line react/jsx-key
                    return <div>{y}</div>;
                })}
                {!props.detailsObj?.payerNotes && (
                    <>
                        No Notes Available
                    </>
                )}
            </div>
            <div className="remaining_total_amount">${props.detailsObj?.amount ?? 0}</div>
        </div>
    );
};
